import React, {memo} from 'react';

import {
  SafeAreaView,
  View,
  useWindowDimensions,
  Platform,
} from 'react-native';

import DragList, {
  DragListRenderItemInfo,
} from 'react-native-draglist';

// import {FolderPreviewContentType} from '../../hooks/useFolders';

import ContentItem from '../folder/items/contentitem';
import {useFolder} from '../../hooks/useFolder';
import {
  ActivityIndicator,
  IconButton,
  List,
} from 'react-native-paper';
import {useIsFocused, useRoute} from '@react-navigation/native';
import {
  FolderPreviewContentType,
  FolderType,
  MinimalProduct,
} from '../../types';
import {ScrollView} from 'react-native-gesture-handler';
import {getById, getFolderContent, writeItem} from '../../api';
import {FolderParams} from '../../types/nav';
import {OrdersPage} from './orders';
import {styles} from '../folder/styles';
import {useQuery} from 'react-query';
import {getOrderById} from '../../api/exchange';

export interface OrderParams {
  orderId?: string;
  shopId?: string;
}
const OrderPage = (props: OrderParams) => {
  const isFocused = useIsFocused();
  const {height, width} = useWindowDimensions();
  const isMobile = width > 700 ? false : true;
  const route = useRoute();
  let marginTop = Platform.OS === 'web' ? 0 : 0;
  const params = route.params as OrderParams;
  const dataHook = useQuery(
    'orderData_' + params.orderId,
    async () => {
      const order = await getOrderById(params.orderId as string);
      console.info(order);
      cart = [];
      cart = await Promise.all(
        order.userData?.cart.map(
          async (c: MinimalProduct) =>
            await getById(c.id, props.shopId),
        ),
      );
      console.info('cart', cart);
      return cart;
    },
  );
  const orderContent = dataHook.data;

  const mstyles = styles;
  mstyles.item.width = width - 80;
  mstyles.scroll.height = height - 65;
  mstyles.scroll.marginTop = marginTop;
  if (!isFocused) return <></>;
  const renderContent = ({
    item: i,
    onDragEnd,
    onDragStart,
  }: DragListRenderItemInfo<FolderPreviewContentType>) => (
    <ContentItem
      i={i}
      key={i.id}
      dataHook={dataHook}
      styles={mstyles}
      width={!isMobile ? (width / 100) * 70 : width}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    />
  );
  return (
    // <SafeAreaView>
    <View
      style={{
        height: '100%',
        width: '100%',
        flexDirection: 'row',
      }}>
      {!isMobile ? (
        <View style={{width: '40%'}}>
          <OrdersPage />
        </View>
      ) : null}
      {!dataHook.isFetching && orderContent !== undefined ? (
        <DragList
          renderItem={renderContent}
          keyExtractor={item => item?.id || item?.date.toString()}
          style={{
            width: '60%',
            height,
            paddingBottom: 50,
          }}
          data={orderContent}
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          scrollEnabled={true}
        />
      ) : (
        <ActivityIndicator size={72} />
      )}
    </View>
    // </SafeAreaView>
  );
};

export default memo(OrderPage);
